import type { MzIconProps } from '@monizze/monizze-components';
import { PhChatCircle, PhDeviceMobileCamera, PhEnvelopeSimple, PhHeadset, PhKey, PhPhone, PhWhatsappLogo } from '@phosphor-icons/vue';
import { MessageChannel } from '@/types/MessageChannel.ts';

const methodIcons = {
	sms: PhPhone,
	email: PhEnvelopeSimple,
	totp: PhDeviceMobileCamera,
	totpRecovery: PhKey,
	support: PhHeadset,
} as const;

export type MethodType = keyof typeof methodIcons;

export const getMethodIcon = (methodType: MethodType): MzIconProps['icon'] => {
	return methodIcons[methodType] || PhEnvelopeSimple;
};

const phoneIcons = {
	sms: PhChatCircle,
	whatsapp: PhWhatsappLogo,
	call: PhPhone,
} as const;

export const phoneMethodIcon = (channel: MessageChannel): MzIconProps['icon'] => {
	return phoneIcons[channel];
};

// MFA phone targets arrive in international format without the leading "+" (e.g. "32491739844"). Restore it for
// display. The digit-only check keeps this safe on the shared screens that may render an email instead, which is
// returned untouched.
export const displayPhone = (value?: string | null): string => {
	const phone = value ?? '';
	return /^\d+$/.test(phone) ? `+${phone}` : phone;
};
